/**
 * MyList
 */

import List from '../List';
import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class MyList extends List {

	protected $node: any;

	protected _id: any;

	constructor( node: any, options: any ) {
		super( node, options );
		this.$node = node;
		this._id = this.$node.attr( 'id' );
		this.hideMenu();
	}

	public hideMenu() {
		jQuery( `#${this._id} .board-top-utils` ).hide();
	}

	public get( apiUrl: string ) {
		const _param = Util.getParams();
		const page = _param.page || 1;
		const pInfo = this.paramInfo;
		const url = apiUrl;
		const isVote = ( Config.isVote && Util.net( '' ) !== 'opdev' ) ? 'true' : 'false';

		pInfo.setParamByUrl();
		pInfo.setParam( ['viewMode', this.viewMode || '' ] );

		const list: any = Util.get( url, 'GET', {
			size: Config.listSize,
			page,
			query: decodeURIComponent( pInfo.getParamByKey( 'query' ) ),
			searchType: pInfo.getParamByKey( 'searchType' ),
			categoryId: pInfo.getParamByKey( 'categoryId' ),
			summary: ( pInfo.getParamByKey( 'viewMode' ) === 'card' ) ? true : false,
			guid: Config.userGuid || '',
			gameUserUid: Config.gameUserUid || '',
			gameCharacterId: Config.gameCharacterId || '',
			gameServerId: Config.gameServerId || '',
			isVote,
		});
		const list$ = Util.from( list );
		list$.subscribe( ( data: any ) => {
			let tmp = '';

			// data is null
			if ( !data ) {
				this.$node.append( Template.empty( this.listId, Config.L10N.list_none_article ) );
				this.isFirstLoaded = true;
				this.loading.hide();
				return;
			}

			// my API
			if ( data.userArticleList ) {
				data.articleList = data.userArticleList;
			}

			// bookmark have not articleList.
			if ( data.scrapList ) {
				data.articleList = data.scrapList;
			}

			// empty listNode
			this.remove();

			// set data to search Module
			this.search.setQuery( decodeURIComponent( pInfo.getParamByKey( 'query' ) ) );
			this.search.setSearchType( pInfo.getParamByKey( 'searchType' ) );

			const searchUI = this.search.setResultUI( data.pageNavigation.totalCount || 0 );

			// empty data
			if ( data.articleList.length === 0 && !this.isFirstLoaded ) {
				( this.search.getQuery() &&  this.search.getSearchType() ) ?
					this.$node.append( Template.emptySearch( this.listId, Config.L10N.search_none ) ) :
					this.$node.append( Template.empty( this.listId, Config.L10N.list_none_article ) );

				this.loading.hide();
				return;
			}

			const pageUI = this.pageNavigation.setUI( data.pageNavigation );

			if ( this.viewMode === 'card' && Config.isCardView ) {
					tmp = Template.cardList( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			} else {
					tmp = Template.list( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			}

			// list template + page navigation
			tmp = Util.Tmpl.join( searchUI + tmp, pageUI );

			// append template data
			this.$node.append( tmp );

			this.isFirstLoaded = true;

			this.loading.hide();

			jQuery( 'li.board-items' ).css( 'cursor', 'pointer' );

		}, ( data: any ) => {
			this.loading.hide();
			// Config.apiError( data );
		});
	}
}

export default MyList;
